var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-index-carousel"},[_vm._t("default"),_c('div',{staticClass:"dots"},_vm._l((_vm.slides),function(slide,index){return _c('div',{key:index,staticClass:"dot",class:[{ active: _vm.current === index }]})}),0)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }